import { Component, OnInit, Input, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Task, TaskComment, Client } from '@store/models';
import { AuthSelectors, TasksDispatchers, TasksSelectors, ClientsSelectors, SessionSelectors } from '@store';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-task',
    template: `
        <app-task-ui
            [userCard]="userCard$ | async"
            [taskUsers]="taskUsers$ | async"
            [allUsers]="allUsers$ | async"
            [task]="task"
            [taskClient]="taskClient$ | async"
            [taskComments]="taskComments$ | async"
            [taskDescription]="taskDescription$ | async"
            [showDone]="showDone"
            [showReject]="showReject"
            (saveTask)="onSaveTask($event)"
            (saveTaskComment)="onSaveTaskComment($event)"
        ></app-task-ui>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TaskContainerComponent implements OnInit, OnDestroy {

    taskUsers$ = this.sessionSelector.users$(new Date());
    allUsers$ = this.sessionSelector.users$();
    userCard$ = this.authSelector.userCard$;
    taskComments$ = this.tasksSelector.taskComments$;
    taskDescription$ = this.tasksSelector.taskDescription$;
    taskClient$: Observable<Client>;
    @Input() task: Task;
    @Input() showDone: boolean;
    @Input() showReject: boolean;

    constructor(
        private activeModal: NgbActiveModal,
        private tasksDispatch: TasksDispatchers,
        private tasksSelector: TasksSelectors,
        private sessionSelector: SessionSelectors,
        private clientsSelector: ClientsSelectors,
        private authSelector: AuthSelectors,
    ) {}

    ngOnInit() {
        if (!this.task) { return; }
        this.tasksDispatch.loadTaskComments(this.task);
        this.taskClient$ = this.clientsSelector.clientByKid$(this.task.kid);
    }

    ngOnDestroy() {
        this.tasksDispatch.resetTaskComments();
    }

    onSaveTask(task: Task) {
        if (task.lid > 0) {
            this.tasksDispatch.updateTask(task);
        } else {
            this.tasksDispatch.createTask(task);
        }
        this.activeModal.close();
    }

    onSaveTaskComment(taskComment: TaskComment) {
        this.tasksDispatch.createTaskComment(taskComment);
    }

}
